import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import VideoState from '../stores/root-store/video.state';
import {
    ReplayVideoAction,
    SetVideoStateTypeAction
} from '../stores/root-store/actions/video.action';
import {VideoStateEnum} from '../../../enums/video-state.enum';
import {Subject} from 'rxjs';
import {selectActualVideoState} from '../stores/root-store/selectors/video.selector';
import {first, filter} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BufferService {
    $overlayClicked = new Subject();

    constructor(private store: Store<{ video: VideoState }>) { }

    playVideo() {
        this.replayIfEnded();
        this.store.dispatch(SetVideoStateTypeAction({
            videoState: VideoStateEnum.Playing
        }));
    }

    private replayIfEnded() {
        this.store.select(selectActualVideoState).pipe(
            first(),
            filter(state => state === VideoStateEnum.Ended)
        ).subscribe(() => this.store.dispatch(ReplayVideoAction()));
    }

    playOrPauseVideo(isVideoPlaying) {
        if (isVideoPlaying) {
            this.stopVideo();
        } else {
            this.playVideo();
        }
    }

    stopVideo() {
        this.store.dispatch(SetVideoStateTypeAction({
            videoState: VideoStateEnum.UserPause
        }));
    }
}
